import store from '../app/store';

export const getAccessToken = () => {
    return store.getState().user.access_token;
}